// Same-origin JSON fetch that carries the Rails CSRF token (from the layout's csrf_meta_tags) so the
// frontdesk_v2 JSON endpoints accept non-GET requests under normal session auth.
const csrfToken = () =>
  (typeof document !== "undefined" &&
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")) ||
  "";

// Thrown when the response isn't JSON — typically a session-expired redirect to the login page or an
// HTML error page. Callers can branch on `error.code`.
export class ApiError extends Error {
  constructor(code, status) {
    super(code);
    this.code = code;
    this.status = status;
  }
}

export const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
      ...(options.headers || {}),
    },
    ...options,
  });
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    throw new ApiError(
      response.redirected ? "session_expired" : "non_json_response",
      response.status,
    );
  }
  return response.json();
};
